'use client';
import { DataLayerWhere } from '@/modules/cart/services/data-layer-events/add-to-cart';
import ProductCarouselShelf from '@/modules/common/components/ProductCarouselShelf';
import { useSkuSearch } from '@/modules/product/hooks/useSkuSearch';
import { DataLayerFeature } from '@/modules/product/services/data-layer-events/add-to-wishlist';

import { BlogProduct } from '../model/blog-product.interface';

type BlogRecommendationProductsProps = {
  blogProducts: BlogProduct[];
  blogSlug?: string | null;
  blogTitle?: string | null;
  itemListId?: string;
  itemListName?: string;
  itemListType?: string;
  title: string | null;
};

export const BlogRecommendationProducts = ({
  blogProducts,
  blogSlug,
  blogTitle,
  itemListId,
  itemListName,
  itemListType,
  title,
}: BlogRecommendationProductsProps) => {
  const skus = blogProducts?.map((product) => product.sku) ?? [];
  const { products, isPending } = useSkuSearch(skus);

  return (
    <ProductCarouselShelf
      feature={DataLayerFeature.Blog}
      isQuickView
      itemListId={itemListId || `${blogSlug || 'BlogRecommendationProducts'}-recommendations`}
      itemListName={
        itemListName || `${blogTitle || title || 'BlogRecommendationProducts'} recommendations`
      }
      itemListType={itemListType || `Blog recommendations`}
      loading={isPending}
      products={products}
      showMoreCallback={() => {}}
      title={title ?? ''}
      where={DataLayerWhere.Recommendations}
    />
  );
};
